export const ADMIN_LOGIN = "ADMIN_LOGIN";
export const PROFILE_DETAIL="PROFILE_DETAIL";